const ROLLBACK_RETRY_COUNT = 2;

const rollbackCreatedPreset = async ({ presetId, sdk, Logger }) => {
  for (let attempt = 0; attempt <= ROLLBACK_RETRY_COUNT; attempt += 1) {
    try {
      await sdk.websiteSettingsPresets.delete(presetId);
      return true;
    } catch (deleteError) {
      if (attempt === ROLLBACK_RETRY_COUNT) {
        Logger.error(new Error('Error rolling back website preset after failed image upload'), { error: deleteError }, [
          'RollbackWebsitePresetFailed',
          { errorMessage: (deleteError && deleteError.message) || 'NoMessage', presetId },
        ]);
        return false;
      }
    }
  }

  return false;
};

export default rollbackCreatedPreset;
